export default __webpack_public_path__ + "static/cruiselines-vv-activities-3-0d940690cb760266876e8b787fc5cb57.jpg";